import { Dialog } from '@mnd-frontend/ui/publish/components';
import { GREY_400 } from '@mnd-frontend/ui/shared/tokens';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import MaterialItem from '../../components/MaterialItem';
import { UnscheduleRelatedMaterialContext } from '../../contexts/UnscheduleRelatedMaterialContext';

const MaterialItemWrapper = styled.div`
  text-align: left;
  > div {
    padding: 0.75rem;
  }
  > div + div {
    border-top: 1px solid ${GREY_400};
  }
`;

const UnscheduleRelatedMaterialModal = () => {
  const { t } = useTranslation();

  const {
    state: { show, onAction, material, loading },
  } = useContext(UnscheduleRelatedMaterialContext);

  const pendingMaterial = useMemo(
    () => material?.relatedMaterial.filter(m => m.status === 'scheduled'),
    [material],
  );
  const pendingMaterialSet = useMemo(
    () => new Set(pendingMaterial?.map(m => `${m.__typename}:${m.id}`)),
    [pendingMaterial],
  );

  const pendingMedia = material?.relatedMedia.filter(
    m => m.status === 'scheduled' && !pendingMaterialSet.has(`${m.__typename}:${m.id}`),
  );

  return (
    <Dialog
      open={show}
      confirmAction={{
        onClick: () => onAction(false),
        loading,
        text: t('publish_pr-edit_related-material_schedule-modal-keep-schedule'),
      }}
      secondaryAction={{
        onClick: () => onAction(true),
        text: t('publish_pr-edit_related-material_schedule-modal-set-draft'),
      }}
      description={t('publish_pr-edit_related-material_schedule-modal-description')}
    >
      <MaterialItemWrapper>
        {pendingMaterial?.map(item => (
          <MaterialItem key={item.id} item={item} />
        ))}
        {pendingMedia?.map(item => (
          <MaterialItem key={item.id} item={item} />
        ))}
      </MaterialItemWrapper>
    </Dialog>
  );
};

export default UnscheduleRelatedMaterialModal;
